<header @headerIn>
  <dx-toolbar class="header-toolbar">
    <dxi-item location="before" cssClass="header-logo" locateInMenu="never">
      <div *dxTemplate>
        <a [routerLink]="['/']">
          <img
            class="select-none"
            src="assets/images/tracagri_logo_color.svg"
          />
        </a>
      </div>
    </dxi-item>
    <dxi-item
      location="before"
      widget="dxButton"
      locateInMenu="before"
      [options]="mapMenuItem"
    >
    </dxi-item>

    <dxi-item location="before" locateInMenu="before">
      <div *dxTemplate>
        <dx-button
          class="equipments-button header-menu-button"
          text="Équipements"
          [icon]="'<svg>' + tractorIcon.body + '</svg>'"
          stylingMode="text"
        >
        </dx-button>

        <dx-context-menu
          [items]="equipmentsMenuList"
          target=".equipments-button"
          (onInitialized)="menus.push($event.component)"
          (onShown)="hideOthers($event)"
          showEvent="dxhoverstart"
          width="100%"
          [position]="{ my: 'top left', at: 'bottom left' }"
          cssClass="submenu"
        >
        </dx-context-menu>
      </div>
    </dxi-item>

    <dxi-item location="before" locateInMenu="before">
      <div *dxTemplate>
        <dx-button
          class="fields-button header-menu-button"
          text="Parcelles"
          [icon]="'<svg>' + fieldIcon.body + '</svg>'"
          stylingMode="text"
        >
        </dx-button>

        <dx-context-menu
          [items]="fieldsMenuItem"
          target=".fields-button"
          (onInitialized)="menus.push($event.component)"
          (onShown)="hideOthers($event)"
          showEvent="dxhoverstart"
          width="100%"
          [position]="{ my: 'top left', at: 'bottom left' }"
          cssClass="submenu"
        >
        </dx-context-menu>
      </div>
    </dxi-item>

    <dxi-item location="before" locateInMenu="before">
      <div *dxTemplate>
        <div class="relative inline-block">
          <dx-button
            class="interventions-button header-menu-button"
            text="Interventions"
            [icon]="'<svg>' + interventionIcon.body + '</svg>'"
            stylingMode="text"
          >
          </dx-button>
          <span *ngIf="pendingInterventionsCount > 0 && user.can('list reconstructed_interventions')" 
                class="button-badge">{{pendingInterventionsCount > 99 ? '99+' : pendingInterventionsCount}}</span>
        </div>

        <dx-context-menu
          [items]="interventionsMenuItem"
          target=".interventions-button"
          (onInitialized)="menus.push($event.component)"
          (onShown)="hideOthers($event)"
          showEvent="dxhoverstart"
          width="100%"
          [position]="{ my: 'top left', at: 'bottom left' }"
          cssClass="submenu"
        >
        </dx-context-menu>
      </div>
    </dxi-item>

    <dxi-item location="before" locateInMenu="before">
      <div *dxTemplate>
        <dx-button
          class="manage-button header-menu-button"
          text="Gestion"
          [icon]="'<svg>' + manageIcon.body + '</svg>'"
          stylingMode="text"
        >
        </dx-button>

        <dx-context-menu
          [items]="usersMenuList"
          target=".manage-button"
          (onInitialized)="menus.push($event.component)"
          (onShown)="hideOthers($event)"
          showEvent="dxhoverstart"
          width="100%"
          [position]="{ my: 'top left', at: 'bottom left' }"
          cssClass="submenu"
        >
        </dx-context-menu>
      </div>
    </dxi-item>

    <dxi-item location="after" widget="dxButton" locateInMenu="never">
      <div *dxTemplate="let itemData of 'listItem'">
        <app-notifications-panel></app-notifications-panel>
      </div>
    </dxi-item>

    <dxi-item location="after" locateInMenu="never">
      <div *dxTemplate>
        <dx-button
          class="profile-button header-menu-button"
          [text]="user.name"
          [icon]="'<svg>' + profileIcon.body + '</svg>'"
          stylingMode="text"
        >
        </dx-button>

        <dx-context-menu
          [items]="profileMenuList"
          target=".profile-button"
          (onInitialized)="menus.push($event.component)"
          (onShown)="hideOthers($event)"
          showEvent="dxhoverstart"
          width="100%"
          [position]="{ my: 'top left', at: 'bottom left' }"
          cssClass="submenu"
        >
        </dx-context-menu>
      </div>
    </dxi-item>
  </dx-toolbar>
</header>
